import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initPwaRuntime, setWaitingWorker } from './pwa/runtime';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

initPwaRuntime();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    setWaitingWorker(registration.waiting ?? null);
  },
});
